<template>
  <header class="section-header">
    <div class="quiz_title" v-html="details.quiz_title"></div>
    <svg @click="resetQuiz" xmlns="http://www.w3.org/2000/svg" id="headericon" width="91.798" height="91.798" viewBox="0 0 91.798 91.798">
      <path id="Tracé_24" data-name="Tracé 24" d="M292.121,240.5a45.877,45.877,0,0,0-11.253-30.029,1.345,1.345,0,0,0-2.029,1.766,43.157,43.157,0,0,1,9.485,18.619,31.288,31.288,0,0,0-9.986-7.582,56.463,56.463,0,0,0-10.728-4.084,56.408,56.408,0,0,0-4.084-10.728,31.283,31.283,0,0,0-7.582-9.985,43.165,43.165,0,0,1,18.548,9.423,1.345,1.345,0,1,0,1.76-2.033,45.9,45.9,0,0,0-75.929,34.712v.078a45.87,45.87,0,0,0,11.245,30.019,1.344,1.344,0,1,0,2.028-1.764,43.164,43.164,0,0,1-9.477-18.611,31.271,31.271,0,0,0,9.986,7.582,56.44,56.44,0,0,0,10.727,4.084,56.46,56.46,0,0,0,4.084,10.728,31.275,31.275,0,0,0,7.582,9.985,43.157,43.157,0,0,1-18.611-9.477,1.344,1.344,0,1,0-1.764,2.029,45.872,45.872,0,0,0,30.02,11.245h.077a45.9,45.9,0,0,0,45.9-45.9Zm-76.453-30.477a42.935,42.935,0,0,1,20.88-11.575,31.511,31.511,0,0,0-7.811,10.368l-1.487-4.451a1.345,1.345,0,1,0-2.551.852l2.57,7.69a1.345,1.345,0,0,0,1.275.919,1.362,1.362,0,0,0,.427-.069l7.689-2.571a1.344,1.344,0,1,0-.852-2.55l-4.77,1.594c4.043-8.215,9.482-12.862,15.185-12.862,5.554,0,10.849,4.374,14.91,12.317a52.326,52.326,0,0,1,3.466,8.749,83.5,83.5,0,0,0-18.376-1.981c-12.11,0-23.515,2.422-32.116,6.819a31.259,31.259,0,0,0-10.007,7.608A42.932,42.932,0,0,1,215.668,210.019Zm8.411,48.93a52.362,52.362,0,0,1-8.749-3.466c-7.943-4.061-12.317-9.356-12.317-14.91s4.374-10.849,12.317-14.91a52.47,52.47,0,0,1,8.755-3.468,86.107,86.107,0,0,0-.006,36.754Zm22.143,24.833c-5.554,0-10.849-4.374-14.91-12.317a52.353,52.353,0,0,1-3.466-8.748,83.544,83.544,0,0,0,18.376,1.98,87.709,87.709,0,0,0,9.41-.5l-2.938,4.109a1.344,1.344,0,1,0,2.187,1.564l4.716-6.6a1.338,1.338,0,0,0,.25-.743,1.388,1.388,0,0,0-.013-.249,1.345,1.345,0,0,0-.713-1l-6.432-4.6a1.345,1.345,0,1,0-1.564,2.188l3.774,2.7a85.1,85.1,0,0,1-8.679.44,79.913,79.913,0,0,1-19.188-2.247,82.912,82.912,0,0,1,.009-38.377,83.067,83.067,0,0,1,38.367,0,82.94,82.94,0,0,1-.157,38.993,1.357,1.357,0,0,0-.076.287,54.274,54.274,0,0,1-4.045,10.8C257.071,279.408,251.776,283.782,246.222,283.782Zm30.554-12.655a42.93,42.93,0,0,1-20.857,11.57,31.258,31.258,0,0,0,7.608-10.007,56.412,56.412,0,0,0,4.086-10.734c9.457-2.593,16.662-6.747,20.739-11.713A42.926,42.926,0,0,1,276.776,271.127Zm6.417-19.549a43.077,43.077,0,0,1-14.826,7.363,86.217,86.217,0,0,0,0-36.744,52.43,52.43,0,0,1,8.749,3.466c7.943,4.061,12.317,9.356,12.317,14.91C289.431,244.429,287.274,248.235,283.192,251.577Z" transform="translate(-200.323 -194.674)"/>
    </svg>
  </header>
</template>

<script>
import { mixins } from '../mixins/mixins.js'

export default {
  name: 'sectionHeader',
  mixins: [mixins],

  computed: {
    details () {
      return this.$store.state.details
    }
  }
}
</script>

<style lang="scss">
  .section-header {
    padding: 25px 0;
    width: 100%;
    display: flex;
    align-items: center;
    margin-bottom: 23vh;

    @media all and (max-width: 768px) {
      margin-bottom: 0px;
      font-size: 12px;
    }

    @media all and (max-width: 540px) {
      //@at-rootmargin-bottom: inherit;
    }

    #headericon {
      margin-left: auto;
      width: 40px;
      height: 40px;
      fill: #000;
      cursor: pointer;

      @media all and (max-width: 540px) {
        width: 30px;
      }
    }

    .quiz_title {
      display: block;
      position: relative;
      width: calc(100% - 0px);
      margin-top: 20px;
      margin-left: -70px;
      border-top: 1px solid #000;

      @media all and (max-width: 540px) {
        margin-left: -55px;
        margin-top: 14px;
      }

      br {
        display: none;
      }
    }
  }
  .about .section-header {
    .quiz_title {
      color: #fff;
      border-color: #fff;
      text-align: right;
    }

    #headericon {
      fill:#fff;
    }

    @media all and (max-width: 1024px ) {
      margin-bottom: 5em;
    }
  }
</style>
